import Spinner from "@/components/icons/Spinner";

import { handleAddItemToCart } from "@/utils/product/addToCartFunc";
import { useCart } from "@/context/cart";
import { useState, useContext } from "react";
import { useTranslation } from "next-i18next";
import { ModalContext } from "@/pages/_app";
import { retainKeys } from "@/utils/product";
import { useClient } from "@/hooks/useClient";
import { notifyMe } from "@/services/global";
import ProductCartIcon from "@/components/icons/ProductCartIcon";
import { deleteCookie, getCookie, setCookie } from "cookies-next";
import { event_add_to_cart, event_view_item } from "@/utils/gtm";
import { getSession } from "next-auth/react";
import toast from "react-hot-toast";

const AddToCart = ({ product, qty = 1, fromPDP, relatedProducts }) => {
  const { t } = useTranslation("common");
  const { dispatch } = useCart();
  const context = useContext(ModalContext);
  const [loading, setLoading] = useState(false);
  const { isClient } = useClient();
  const handshake = getCookie("handshake");

  const isEnabled =
    product?.stock?.qty >= 0 && product?.stock?.is_in_stock == true;
  const isConfigurable = product?.type_id == "configurable";
  const configurations =
    isClient &&
    Object.values(
      retainKeys(product?.selectedConfigurations, ["attribute_id", "option_id"])
    );
  const handleNotifyMe = async (entity_id) => {
    const session = await getSession();
    const userId = session?.user?.id;
    console.log("Notifyyyyyyyyyyyyyyyyyyyy");
    event_view_item(product, "notify_me_clicked");
    if (userId) {
      const res = await notifyMe(handshake, entity_id, userId); // , entity_id, userId
      !res?.data?.data?.[0]?.error &&
        toast.success(t("You will be reminded when the product is available."));
      deleteCookie("currEntity_id");
    } else {
      setCookie("currEntity_id", entity_id);
      context?.dispatch({ type: "auth" });
    }
  };

  return (
    <button
      title={isEnabled ? t("Add to cart") : t("Notify me when Avaliable")}
      onClick={() => {
        if (isEnabled) {
          handleAddItemToCart(
            product,
            qty,
            setLoading,
            dispatch,
            isConfigurable ? configurations : null,
            context,
            relatedProducts
          );
          event_add_to_cart(product, qty);
        } else {
          handleNotifyMe(product?.entity_id);
        }
      }}
      className={`flex items-center justify-center gap-2 w-full p-2 rounded-md ${
        isEnabled
          ? "bg-primary text-white"
          : "bg-red-500 text-white font-bold cursor-pointer"
      } transition-colors duration-500 hover:opacity-95 disabled:opacity-75`}
      aria-label={isEnabled ? "Add to cart" : "Notify me when Avaliable"}
    >
      {loading ? (
        <Spinner className="size-[18px]" />
      ) : (
        !fromPDP &&
        isEnabled && <ProductCartIcon className="size-3 sm:size-[18px]" />
      )}
      <span
        className={`font-semibold ${
          fromPDP ? "text-sm" : "text-sm max-sm:text-xs"
        }`}
      >
        {isEnabled ? t("Add To Cart") : t("Notify me when Avaliable")}
      </span>
    </button>
  );
};

export default AddToCart;
